<template>
  <div class="card">
    <div class="card-header cursor-pointer">
      <div
        class="card-title m-0 d-flex justify-content-between align-items-center"
      >
        <h3 class="fw-bold m-0">{{ $t('account.addresses') }}</h3>

        <button @click="openDetail()" class="btn btn-primary rounded-sm">
          {{ $t('global.addNew') }}
        </button>
      </div>
    </div>
    <div class="card-body">
      <!-- List Table -->
      <List
        :header="header"
        :data="data"
        :pagination="pagination"
        :loading="loading"
        @updatePage="updatePage"
        :moduleName="`account.addresses`"
      >
        <template v-slot:item.address="{ item }">
          {{ item.line1 }} {{ item.line2 }}
        </template>

        <template v-slot:item.location="{ item }">
          {{ item.city }}
          {{
            item.country && item.country.data
              ? ' / ' + item.country.data.name
              : ''
          }}
        </template>

        <template v-slot:item.is_invoice_address="{ item }">
          <i
            :class="
              (item.is_invoice_address
                ? 'cursor-not-change'
                : 'cursor-change') + (item.is_invoice_address ? ' fas' : ' far')
            "
            class="fa-star text-primary"
            @click="setAsAddress(item)"
          ></i>
        </template>

        <template v-slot:item.action="{ item }">
          <ActionButton
            icon="fas fa-pencil"
            :title="$t('global.update')"
            class="mr-2"
            @click.native="clickField(item)"
          ></ActionButton>

          <DeleteButton
            icon="fad fa-trash"
            :title="$t('global.delete')"
            @click.native="openDeleteHandler(item)"
          ></DeleteButton>
        </template>
      </List>
    </div>

    <!-- Create Popup -->
    <DetailModal
      :title="
        $t(
          selectedItem == ''
            ? 'account.createNewAddress'
            : 'account.updateAddress'
        )
      "
      :show="showDetail"
      @closeDetail="closeDetail()"
      @confirm="confirmModal()"
      :resetForm="resetForm"
    >
      <AddressForm
        :confirmModal="confirmCreate"
        @resetDetailForm="resetDetailForm"
        :selectedItem="selectedItem"
      />
    </DetailModal>

    <DeleteOperation :url="deleteOperationUrl" @updateList="getList" />
  </div>
</template>

<script>
// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'Address',
  props: {
    user: Array | String,
  },
  data() {
    return {
      search: '',
      filters: '',
      showDetail: false,
      loading: false,
      header: [
        { text: 'account.addressName', value: 'name' },
        { text: 'account.address', value: 'address' },
        { text: 'global.email', value: 'email_address' },
        { text: 'global.location', value: 'location' },
        {
          text: 'account.isInvoiceAddress',
          value: 'is_invoice_address',
          size: '150px',
        },
        { text: this.$t('global.actions'), value: 'action', size: '100px' },
      ],
      data: [],
      pagination: {},
      meta: {},
      deleteOperationUrl: '',
      selectedItem: '',
      confirmCreate: false,
      resetForm: false,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true

      const { current_page } = this.meta

      // `/users/${this.currentUser.user.id}/addresses`
      let $query = `accounts/addresses?position=id|desc&page=${
        current_page ? current_page : 1
      }`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    openDetail() {
      this.selectedItem = ''
      this.showDetail = true
    },
    closeDetail() {
      this.selectedItem = ''
      this.showDetail = false
    },
    clickField(item) {
      this.selectedItem = item
      this.showDetail = true
    },
    openDeleteHandler(item) {
      //`users/${this.currentUser.user.id}/addresses/${item.id}`
      this.deleteOperationUrl = `accounts/addresses/${item.id}`
      this.$bvModal.show('modal-deleteOperation')
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      if (closeDetail) {
        this.closeDetail()
        this.getList()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
    setAsAddress(item) {
      if (item.is_invoice_address) return null

      this.loading = true
      ApiService.put(
        //`users/${this.currentUser.user.id}/addresses/${item.id}/set-as-invoice-address`
        `accounts/addresses/${item.id}/set-as-invoice-address`
      )
        .then((res) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
  components: {
    AddressForm: () => import('@/components/account/forms/AddressForm'),
  },
}
</script>
